import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslationService } from '../core/services/translation.service';
import { APP_TITLE_KEY } from '../dashboard/dashboard.component';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor(
    private translationService: TranslationService,
    private titlesService: Title
  ) { }

  ngOnInit() {
    const title = this.translationService.getTranslationSync(APP_TITLE_KEY);
    this.titlesService.setTitle(title);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/not-found/not-found.component.ts